import {map, take} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {maoMsg$} from '@/raw/mao/index';
import {marginAccountsData$} from './accounts';
import {
  fundAccountsData$,
  fundScaleAccountsData$,
  fundInvalidAccountsData$,
  fundInvalidScaleAccountsData$,
} from './fund-accounts';
import type {FundAccountsData, MarginAccountsData} from '@/types';

export interface UMarginAccounts {
  type: 'margin-trade-accounts';
  data: MarginAccountsData;
}
export interface UMarginAccountStatus {
  type: 'update-margin-account-status';
  data: {
    isActivateMarginAccount: boolean;
  };
}

export interface UFundAccounts {
  type: 'fund-accounts';
  data: FundAccountsData;
}

export interface UFundScaleAccounts {
  type: 'fund-scale-accounts';
  data: FundAccountsData;
}

export interface UFundInvalidAccounts {
  type: 'fund-invalid-accounts';
  data: FundAccountsData;
}

export interface UFundInvalidScaleAccounts {
  type: 'fund-invalid-scale-accounts';
  data: FundAccountsData;
}

export function subscriberAccounts() {
  marginAccountsData$
    .pipe(map((accounts: MarginAccountsData): UMarginAccounts => ({type: 'margin-trade-accounts', data: accounts})))
    .subscribe((msg) => toUiMsg$.next(msg));

  /**
   * 是否激活 Margin Trading 交易账户，默认关闭
   * 当 Margin Trading 账户订阅 mao.subscribe 推送消息，即可认为用户开启（多端时同步账户状态）
   */
  maoMsg$
    .pipe(
      map(() => true),
      take(1)
    )
    .subscribe((isActivateMarginAccount: boolean) =>
      toUiMsg$.next({type: 'update-margin-account-status', data: {isActivateMarginAccount}})
    );
}

export function subscriberFundAccounts() {
  fundAccountsData$
    .pipe(map((accounts: FundAccountsData): UFundAccounts => ({type: 'fund-accounts', data: accounts})))
    .subscribe((msg: UFundAccounts) => toUiMsg$.next(msg));

  fundScaleAccountsData$
    .pipe(map((accounts: FundAccountsData): UFundScaleAccounts => ({type: 'fund-scale-accounts', data: accounts})))
    .subscribe((msg: UFundScaleAccounts) => toUiMsg$.next(msg));

  fundInvalidAccountsData$
    .pipe(map((accounts: FundAccountsData): UFundInvalidAccounts => ({type: 'fund-invalid-accounts', data: accounts})))
    .subscribe((msg: UFundInvalidAccounts) => toUiMsg$.next(msg));

  fundInvalidScaleAccountsData$
    .pipe(
      map(
        (accounts: FundAccountsData): UFundInvalidScaleAccounts => ({
          type: 'fund-invalid-scale-accounts',
          data: accounts,
        })
      )
    )
    .subscribe((msg: UFundInvalidScaleAccounts) => toUiMsg$.next(msg));
}
